import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import STRBanner from './components/STRBanner';
import LoanPrograms from './components/LoanPrograms';
import Testimonials from './components/Testimonials';
import WhereWeLend from './components/WhereWeLend';
import Footer from './components/Footer';
import AboutUsPage from './pages/AboutUsPage';
import TeamPage from './pages/TeamPage';
import LoanDetailPage from './pages/LoanDetailPage';
import DSCRCalculatorPage from './pages/DSCRCalculatorPage';
import DealCalculatorPage from './pages/DealCalculatorPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminImagesPage from './pages/AdminImagesPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminBlogPage from './pages/AdminBlogPage';
import JoinPage from './pages/JoinPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import AgentsPage from './pages/AgentsPage';
import ShortTermRentalPage from './pages/ShortTermRentalPage';

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Close Now Lending | Hard Money, Fix & Flip, DSCR & Real Estate Investment Loans"
        description="Close Now Lending is a nationwide real estate investment lender offering hard money loans, fix and flip financing, cash out refinance, DSCR loans, new construction, and commercial lending. Fast closings in 10 days. Based in Houston, TX."
        keywords="hard money loans, fix and flip loans, cash out refinance, DSCR loans, new construction loans, commercial real estate lending, bridge loans, short term rental loans, real estate investor financing, Houston hard money lender, Close Now Lending, private money lender, asset based lending, investment property loans, rental property financing, real estate bridge loans, fast closing loans, no income verification loans, nationwide hard money lender"
        url="/"
      />
      <Header />
      <Hero />
      <STRBanner />
      <Testimonials />
      <LoanPrograms />
      <WhereWeLend />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/loan-programs/:slug" element={<LoanDetailPage />} />
          <Route path="/dscr-calculator" element={<DSCRCalculatorPage />} />
          <Route path="/deal-calculator" element={<DealCalculatorPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/images" element={<AdminImagesPage />} />
          <Route path="/admin/blog" element={<AdminBlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/short-term-rental" element={<ShortTermRentalPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
